import React, { useCallback, useEffect, useState } from 'react';
import serviceDestaques from '../../services/destaquesHome';
import './Home.scss';
import bannerCadastro from './../../assets/images/bannerHomeCadastro.png';
import { useHistory } from 'react-router';
// import { useDispatch } from 'react-redux';
// import { actions as actionsHeader} from '../../redux/actions/header'
const Home = props => {

    const [imagens, setImagens] = useState([]);
    const history  = useHistory();
    let indexAtualCarrossel = 0;
    const tempoRotacaoCarrossel = 7000;
    //let carrosselTime = null;

    const carregarImagens = useCallback(async () => {
        const res = await serviceDestaques.getListHome();
        setImagens(res.rows);
    }, []);

    useEffect(() => {
        carregarImagens();
    }, [carregarImagens]);

    const animaCarrosselFade = () => {
        
        const imagensCarrossel = imagens.filter(e => {
            return e.carrossel === true;
        });

        let proximoIndex = indexAtualCarrossel + 1;
        if (imagensCarrossel.length === proximoIndex) {
            proximoIndex = 0;
        }

        const sliders = document.querySelectorAll('.slider');
        if(sliders.length){

            sliders[indexAtualCarrossel].classList.remove('show');
            sliders[proximoIndex].classList.add('show');
            
            indexAtualCarrossel = proximoIndex;
            
            setTimeout(() => {
                animaCarrosselFade();
            }, tempoRotacaoCarrossel);
        }
    }

    const renderCarrossel = () => {
        const imagensCarrossel = imagens.filter(e => {
            return e.carrossel === true;
        });

        if (imagensCarrossel.length > 0) {
            const result = imagensCarrossel.map((ele, index) => {
                return (
                    <div className={index === 0 ? "slider show" : "slider"} key={ele._id}>
                        {ele.url && <a href={ele.url} target={ele.janela}><img src={ele.imagem} alt={ele.descricao} /></a>}
                        {!ele.url && <img src={ele.imagem} alt={ele.descricao} />}
                    </div>
                )
            });
            setTimeout(() => { animaCarrosselFade() }, tempoRotacaoCarrossel);
            return result;
        } else {
            return null;
        }
    }

    const renderImagens = () => {
        return imagens.map((ele, index) => {
            if (ele.carrossel === false) {
                return (
                    <div className="banner" key={index}>
                        {ele.url && <a href={ele.url} target={ele.janela}><img src={ele.imagem} alt={ele.descricao} /></a>}
                        {!ele.url && <img src={ele.imagem} alt={ele.descricao} />}
                    </div>
                )
            } else {
                return <React.Fragment  key={index}></React.Fragment>;
            }
        })
    }

    const openCadastro = _ => {
        history.push("/cadastro");
    }

    return (
        <div className="background home">
            <div className="container">
                <div className="content">
                    <div className="chamadaCadastro">
                        <img src={bannerCadastro} alt=""  onClick={openCadastro} />
                    </div>
                    <div className="carrossel">
                        {renderCarrossel()}
                    </div>
                    {renderImagens()}
                </div>
            </div>
        </div>
    )
};

export default Home;